/**
 * Where to go after signing in. The sign-in email function has no "next"
 * parameter, so the app remembers the destination on this device when the
 * link is requested and uses it when the link comes back. Only in-app paths
 * are accepted, so a crafted link cannot bounce someone to another site.
 */
const KEY = "tfwp.nextAfterSignIn";

export function safeNextPath(next: string | null | undefined): string | null {
  if (!next) return null;
  if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return null;
  if (next.startsWith("/login") || next.startsWith("/auth/")) return null;
  return next;
}

export function rememberNext(next: string | null | undefined) {
  const safe = safeNextPath(next);
  try {
    if (safe) localStorage.setItem(KEY, safe);
    else localStorage.removeItem(KEY);
  } catch {
    /* storage blocked */
  }
}

export function takeNext(): string {
  try {
    const saved = safeNextPath(localStorage.getItem(KEY));
    localStorage.removeItem(KEY);
    return saved ?? "/";
  } catch {
    return "/";
  }
}

/** Signing out forgets where a previous link was headed, so the next person on this device starts at home. */
export function clearNext() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* storage blocked */
  }
}
